module.exports = __webpack_public_path__ + "img/icon_09.63d4072f.gif";